import {Box, Skeleton, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {AppButton, AppButtonVariant} from '@/app/shared-components';

import {FdicIcon} from './FdicIcon';

interface SplitsInvitationCardProps {
  inviterName: string;
  isLoadingSplitData: boolean;
  onContinueFromLanding: () => void;
  onGetAvatarImage: () => React.ReactNode;
}

export function SplitsInvitationCard({
  inviterName,
  isLoadingSplitData,
  onContinueFromLanding,
  onGetAvatarImage,
}: SplitsInvitationCardProps) {
  const {t} = useTranslation();

  return (
    <Box
      component="div"
      className="splits-landing-card splits-landing-card-invitation">
      <Box
        component="div"
        className="splits-landing-card-fdic">
        <FdicIcon />
      </Box>
      <Box className="splits-landing-card-invitation-body">
        {onGetAvatarImage()}
        {isLoadingSplitData ? (
          <>
            <Skeleton
              variant="text"
              animation="wave"
              width="80%"
              className="mx-auto text-[1.5rem]"
            />
            <Skeleton
              variant="text"
              animation="wave"
              width="100%"
              className="text-[1rem]"
            />
          </>
        ) : (
          <>
            <Typography
              className="splits-landing-headline"
              component="h1">
              {t('split_bills_page.landing.invitation_title', {
                name: inviterName,
              })}
            </Typography>
            <Typography className="splits-landing-description">
              {t('split_bills_page.landing.invitation_description')}
            </Typography>
          </>
        )}
        <AppButton
          id="splits-landing-continue"
          onClick={onContinueFromLanding}
          label={t('split_bills_page.landing.continue')}
          variant={AppButtonVariant.onPrimary}
        />
      </Box>
    </Box>
  );
}
